const serverUrl = 'https://naukotheka.ru';

const config = {
  apiUrl: '/api/core',
  authUrl: '/api/a',
  baseUrl: serverUrl,
  executeUrl: '/api/a/login-actions/execute',
  loginUrl: '/api/a/login-actions/authenticate',
  logoutUrl: '/api/a/oauth2c/logout',
  searchUrl: '/api/search',
  signUpUrl: '/api/a/login-actions/register',
  tokenUrl: '/api/a/login-actions/action-token',
  userDataUrl: '/api/a/oauth2c/user/me',
  validateUrl: '/api/a/oauth2c/validate',
  webSocketUrl: serverUrl,
};

export default config;
